import { render, staticRenderFns } from "./RichTextMenuButton.vue?vue&type=template&id=57ca2d55&scoped=true"
import script from "./RichTextMenuButton.vue?vue&type=script&lang=js"
export * from "./RichTextMenuButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ca2d55",
  null
  
)

export default component.exports